<template>
	<div id="exterior">
		<div v-if="isMove" class="bt" @click="move(true)">
			<i class="el-icon-arrow-left"></i>
		</div>
		<div class="menu-parent" :style="'width: '+ menuparent +'px;'">
			<div id="box" class="menu-box" :style="'width: '+ boxwidth +'px;'">
				<div :id="'menu'+index" class="menu" v-for="(item,index) in menu" :key="index" @click="isSelect=item[prop.value]" v-bind:class="{ isselect: isSelect==item[prop.value] }">
					<span>{{item[prop.name]}}</span>
				</div>
			</div>
		</div>
		<div v-if="isMove" class="bt" @click="move(false)">
			<i class="el-icon-arrow-right"></i>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				exterior: '',
				boxwidth: 0,
				isMove: false,
				distance: 0,
				timer: null
			}
		},
		methods:{
			load()
			{
				this.getHeight();
				clearInterval(this.timer);
				setTimeout(()=>{this.getboxwidth();});
				setTimeout(()=>{this.getboxwidth();});
				this.timer=setInterval(()=>{
					this.getHeight();
				},200);
			},
			getHeight()
			{
				let dom=document.getElementById('exterior');
				if(dom!=null)
					this.exterior=dom.offsetWidth;
				this.isMove = this.boxwidth>this.exterior;
			},
			getboxwidth()
			{
				let width=0;
				for(let i in this.menu)
				{
					let dom=document.getElementById('menu'+i);
					if(dom)
					{
						width+=dom.offsetWidth;
					}
				}
				this.boxwidth = width;
				this.isMove = this.boxwidth>this.exterior;
			},
			move(left)
			{
				this.distance+=left?Number((0.7*this.menuparent).toFixed(0)):-(0.7*this.menuparent).toFixed(0);
				this.timers(left)();
			},
			timers(left) {
				return time2=>{
					let div=document.getElementById('box');
					if(div.offsetLeft==0&&this.distance>0)
					{
						this.distance=0;
						return
					}
					if((div.offsetLeft+div.offsetWidth)<this.menuparent&&this.distance<0)
					{
						this.distance=0;
						return
					}
					if (this.distance > 0) {
						this.distance--;
						div.style.left=div.offsetLeft+1+'px';
						setTimeout(this.timers(left), 2);
					}
					else if (this.distance < 0) {
						this.distance++;
						div.style.left=div.offsetLeft+-1+'px';
						setTimeout(this.timers(left), 2);
					}
					else{
						this.distance = 0;
					}
				}
			},
		},
		props: {
			menu: {
				type: Array,
				default: function () {
					return [];
				}
			},
			value: {
				type: String,
				default: ''
			},
			prop: {
				type: Object,
				default: function () {
					return {
						name: 'name',
						value: 'value'
					};
				}
			}
		},
		mounted: function () {
			this.load();
		},
		computed:{
			menuparent()
			{
				return this.exterior-(this.isMove?40:0)-1;
			},
			isSelect: {
				 get () {
					return this.value
				},
				set (value) {
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', value);
					}
					o.input();
				}
			}
		},
		created() {
			window.addEventListener('resize', this.getHeight);
			this.getHeight()
		},
		destroyed() {
			window.removeEventListener('resize', this.getHeight);
			clearInterval(this.timer);
		}
	}
</script>

<style scoped>
	.bt{
		border-radius: 0px;
		width: 20px;
		height: 50px;
		line-height: 50px;
		padding-left: 0px;
		padding-right: 0px;
		/* border: 1px solid #dcdfe6; */
		text-align: center;
		float: left;
		background-color: white;
		z-index: 99;
	}
	.menu-parent{
		position: relative;
		width: 100%;
		height: 52px;
		float: left;
		overflow: hidden;
	}
	.menu{
		width: auto;
		float: left;
		line-height: 50px;
		padding: 0px 12px;
		cursor: pointer;
	}
	.menu:hover{
		background-color: #29a1FA;
	}
	.menu-box{
		position: absolute;
		width: auto;
		height: auto;
		left: 0;
	}
	.isselect{
		background-color: #1991FA;
	}
</style>
